export default __webpack_public_path__ + "static/media/mobile-shape-setup-3.077128f0.svg";